import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import type { Customer } from '@aviaconsole/shared';
import { capi } from '../api/client';
import { useAuth } from '../auth/AuthProvider';
import { useI18n } from '../i18n';
import { formatEur } from '../lib/format';
import { Button, Card, Empty, Loading, PageHeader, vatTreatmentLabel } from '../components/ui';

export function dunningLabel(c: Customer, s: (x: string) => string): string {
  const o = c.dunningOverride as { note?: string } | null;
  return o && Object.keys(o).length ? `Custom · ${o.note ?? ''}` : s('Company default');
}

export function Customers() {
  const { company } = useAuth();
  const { t, s } = useI18n();
  const navigate = useNavigate();
  const q = useQuery({ queryKey: ['customers', company?.id], queryFn: () => capi<Customer[]>('/customers') });
  return (
    <>
      <PageHeader crumb={t('custCrumb')} title={t('custTitle')} sub={t('custSub')} actions={<Button variant="primary" icon="fas fa-plus" onClick={() => navigate('/customers/new')}>{t('custAction')}</Button>} />
      <Card pad={false} className="table">
        {!q.data ? <Loading /> : (
          <table>
            <thead><tr><th>{t('colCustomer')}</th><th>{t('colVatNumber')}</th><th>{t('colTreatment')}</th><th>{t('colTerms')}</th><th>{t('colDunning')}</th><th className="r">{t('colOpen')}</th></tr></thead>
            <tbody>
              {q.data.length === 0 && <Empty />}
              {q.data.map((c) => (
                <tr key={c.id} className="click" onClick={() => navigate(`/customers/${c.id}`)}>
                  <td><div style={{ fontWeight: 600 }}>{c.name}</div><div className="sub">{c.email ?? c.contactName ?? ''}</div></td>
                  <td className="ref">{c.vatNumber ?? '—'}</td>
                  <td>{s(vatTreatmentLabel(c.vatTreatment))}</td>
                  <td className="secondary small">{c.paymentDays} {t('days')}</td>
                  <td className="secondary small">{dunningLabel(c, s)}</td>
                  <td className="amount">{c.openCents ? formatEur(c.openCents) : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Card>
    </>
  );
}
